import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "mk_cookie_notice";

export const CookieNotice = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { try { if (!localStorage.getItem(KEY)) setShow(true); } catch { /* storage blocked */ } }, []);
  if (!show) return null;
  const ok = () => { try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* ignore */ } setShow(false); };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] bg-[#0A0A0A] text-white border border-white/10 p-4 shadow-2xl" role="dialog" aria-label="Cookie notice" data-testid="cookie-notice">
      <div className="flex gap-3">
        <Cookie className="w-5 h-5 text-[#FF6B00] shrink-0 mt-0.5" />
        <div className="text-xs leading-relaxed">
          <p className="font-medium text-sm">Cookies on MRQK UK</p>
          <p className="text-neutral-300 mt-1">We only use strictly-necessary cookies and on-device storage to keep you signed in, remember your basket and process secure payments (Stripe, PayPal). No advertising or tracking cookies are set. <Link to="/privacy" className="underline hover:text-[#FF6B00]" data-testid="cookie-privacy-link">Privacy policy</Link></p>
          <button onClick={ok} className="mt-3 bg-[#FF6B00] text-white px-4 py-1.5 text-xs font-medium hover:bg-white hover:text-black transition-colors" data-testid="cookie-ok">OK, got it</button>
        </div>
      </div>
    </div>
  );
};
